<style scoped lang="scss">
.el-alert--warning {
  &.is-light {
    border: 1px solid #ccecff;
    color: #262626;

    ::v-deep.el-alert__icon {
      color: #1b9aee;
    }
  }
}
</style>
<template>
  <el-alert
    :title="info"
    type="warning"
    show-icon
    :closable="false"
    :class="className"
  />
</template>

<script>
export default {
  name: 'SpGlobalAlertWarning',
  props: {
    info: {
      type: String
    },
    className: {
      type: String
    }
  }
}
</script>
